$("#errorOnRegistration")
  .fadeTo(5000, 500)
  .slideUp(500, function() {
    $("#errorOnRegistration").alert("close");
  });
$("#errorOnLogin")
  .fadeTo(5000, 500)
  .slideUp(500, function() {
    $("#errorOnLogin").alert("close");
  });
$("#realwedding-consult")
  .fadeTo(5000, 500)
  .slideUp(500, function() {
    $("#realwedding-consult").alert("close");
  });
$("#wrongCaptcha")
  .fadeTo(5000, 500)
  .slideUp(500, function() {
    $("#wrongCaptcha").alert("close");
  });
var openLoginModal = function(modalname) {
  //   clearTimeout(window.signUpPrompt);
  // if(modalname == 'forgot_panel') {
  //	$('.reveal-modal').trigger('reveal:close');
  // }
  //$('#loginModal').modal('show');
  //$('#fb_email_error').html('');
  window.location.href = "/login?referrer=/";
};
var openGlobalSearchModal = function(modalname) {
  clearTimeout(window.signUpPrompt);
  $(".reveal-modal").trigger("reveal:close");
  $("#globalSearchModal").modal("show");
};
var openVendorError = function() {
  $("#verrorModal").modal("show");
};

if (/Android|iPhone|iPad|iPod/i.test(navigator.userAgent)) {
  if (!Cookies.get("downloadpopup")) {
    $("#app-fixed-footer").css({ display: "block", "z-index": "3" });
  }
}
var openModal = function() {
  $(".reveal-modal").trigger("reveal:close");
  $("#loginModal").modal("hide");
  $("#downloadModal").modal("show");
};
var appBtn = function() {
  if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
    window.location.href = "https://appsto.re/in/TPdo-.i";
  } else {
    window.location.href =
      "https://play.google.com/store/apps/details?id=com.wedmegood.planner";
  }
};

var closeFooter = function() {
  $("#app-fixed-footer").css("display", "none");
  var date = new Date();
  var minutes = 7;
  date.setTime(date.getTime() + minutes * 60 * 1000);
  Cookies.set("downloadpopup", "true", { expires: date });
};
var submitSms = function(e) {
  e.preventDefault();
  var $input = $(e.target)
    .parents("form")
    .find(".sms-val");
  var $arrowaccess = $(e.target)
    .parents("form")
    .find("#arrowaccess");
  var $spin_loader = $(e.target)
    .parents("form")
    .find(".spin-loader");
  var $tick_sms = $(e.target)
    .parents("form")
    .find(".tick-sms");
  var phNo = $input.val();

  if (isNaN(phNo) || phNo.length != 10) {
    $input.css("border", "1px solid red");
  } else {
    $arrowaccess.css("display", "none");
    $spin_loader.css("display", "block");
    $input.css("border", "1px solid #d5d5d5");
    $.ajax({
      method: "post",
      url: "https://www.wedmegood.com/download_link_sms",
      data: {
        mobile_number: phNo
      },
      success: function(data) {
        $spin_loader.css("display", "none");
        $tick_sms.css("display", "block");
        $input.val("");
      }
    });
  }
};
/*$(function() {
	var today = new Date();
	var dd = today.getDate();
	var mm = today.getMonth()+1; //January is 0!
	var yyyy = today.getFullYear();
	today = dd+'-'+mm+'-'+yyyy;
	$("#hired_date").DateTimePicker({
		parentElement: '#hired-date'
	});
    $( "#functionDate" ).datepicker();

});*/

// Example 1: From an element in DOM
$(".open-wedding-consulting").magnificPopup({
  removalDelay: 500, //delay removal by X to allow out-animation
  callbacks: {
    beforeOpen: function() {
      this.st.mainClass = this.st.el.attr("data-effect");
    }
  },
  midClick: true // allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source.
});

$(function() {
  $("#weddingDate").datepicker();
});

$(function() {
  $(".secondHeader ul li ul li").hover(
    function() {
      $(this)
        .parent()
        .parent()
        .addClass("nav-hover");
      // $(".secondHeader ul .secondhead-menu>a").addClass("nav-hover");
    },
    function() {
      $(this)
        .parent()
        .parent()
        .removeClass("nav-hover");
    }
  );
});

var didScroll;
var lastScrollTop = 0;
var delta = 5;
var navbarHeight = $(".secondHeader").outerHeight();

$(window).scroll(function(event) {
  didScroll = true;
});

setInterval(function() {
  if (didScroll) {
    hasScrolled();
    didScroll = false;
  }
}, 250);

function hasScrolled() {
  var st = $(this).scrollTop();

  // Make sure they scroll more than delta
  if (Math.abs(lastScrollTop - st) <= delta) return;

  // If they scrolled down and are past the navbar, add class .nav-up.
  // This is necessary so you never see what is "behind" the navbar.
  if (st > lastScrollTop && st > navbarHeight && screen.width >= 768) {
    // Scroll Down
    $(".secondHeader")
      .removeClass("nav-down")
      .addClass("nav-up");
    $(".nav-up").slideUp();
  } else {
    // Scroll Up
    if (st + $(window).height() < $(document).height() && screen.width >= 768) {
      $(".secondHeader")
        .removeClass("nav-up")
        .addClass("nav-down");
      $(".nav-down").slideDown();
    }
  }

  lastScrollTop = st;
}

$(function() {
  $("#wmg-messenger-box,#inbox-thread-box").perfectScrollbar();

  // with vanilla JS!
  //  Ps.initialize(document.getElementById('Demo'));
});

var $psClick = $(".psClick");
var searchType = window.location.pathname.split("/")[2];
if (!String.prototype.includes) {
  String.prototype.includes = function(search, start) {
    "use strict";
    if (typeof start !== "number") {
      start = 0;
    }

    if (start + search.length > this.length) {
      return false;
    } else {
      return this.indexOf(search, start) !== -1;
    }
  };
}
$(window).on("hashchange", function() {
  searchType = window.location.pathname.split("/")[2];
  if (window.location.href.includes("#")) {
    window.location.href = window.location.href.replace("#", "");
  }
});
$psClick.mousedown(function(event) {
  var $this = $(this).text();
  $psClick.attr("href", "/search/" + searchType + "/" + $this);
  console.log("oi hoye");
});
